import { Component } from '@angular/core';
import { BlobStorageService } from '../../services/blob-storage.service';

type UploadState = 'idle' | 'uploading' | 'done' | 'error';
type DownloadState = 'idle' | 'downloading' | 'error';

@Component({
  selector: 'app-file-storage-demo',
  templateUrl: './file-storage-demo.component.html',
  styleUrls: ['./file-storage-demo.component.scss']
})
export class FileStorageDemoComponent {

  selectedFile: File | null = null;
  uploadState: UploadState = 'idle';
  downloadState: DownloadState = 'idle';
  uploadedFileName: string | null = null;
  errorMessage: string | null = null;

  constructor(private blobStorageService: BlobStorageService) { }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.selectedFile = input.files?.[0] ?? null;
    this.uploadedFileName = null;
    this.uploadState = 'idle';
    this.downloadState = 'idle';
    this.errorMessage = null;
  }

  upload(): void {
    if (!this.selectedFile) return;
    this.uploadState = 'uploading';
    this.errorMessage = null;

    this.blobStorageService.uploadFile(this.selectedFile, 'videos').subscribe({
      next: result => {
        this.uploadedFileName = result.fileName;
        this.uploadState = 'done';
      },
      error: err => {
        this.uploadState = 'error';
        this.errorMessage = err?.message ?? 'Error al subir el fichero';
      }
    });
  }

  download(): void {
    if (!this.uploadedFileName) return;
    this.downloadState = 'downloading';
    this.errorMessage = null;

    this.blobStorageService.downloadFile(this.uploadedFileName, 'videos').subscribe({
      next: blob => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = this.uploadedFileName!;
        a.click();
        URL.revokeObjectURL(url);
        this.downloadState = 'idle';
      },
      error: err => {
        this.downloadState = 'error';
        this.errorMessage = err?.message ?? 'Error al descargar el fichero';
      }
    });
  }
}
